<template>
  <camoodoo-page icon="help_outline" title="Connecting a Canon Camera">
    <simple-section dark title="Prepare the camera">
      This part is demonstrated on an EOS-M50. For other cameras it might be
      different. It is the same procedure as for the original Canon App.
      Currently you need to join the Camoodoo Beta Programm via Google Play
      Store to be able to connect to Canon Cameras.
      <ol>
        <li>Turn on your Canon camera.</li>
        <li>Open the camera menu.</li>
        <li>Select the "Wireless Communication settings" menu item.</li>
        <li>Select the "Wifi Function" menu item.</li>
        <li>Go to the 2nd page.</li>
        <li>Select "Connect to smartphone".</li>
        <li>Select "Register a device for connection".</li>
        <li>Select "Do not display".</li>
        <li>Wait until the camera has opened the Wifi network.</li>
      </ol>
    </simple-section>
    <simple-section light title="Connect for the first time with Camoodoo">
      When you connect the first time with Camoodoo you need to do this steps:
      <ol>
        <li>Launch Camoodoo on your smartphone.</li>
        <li>Select "Add new camera"</li>
        <li>Select "Canon"</li>
        <li>Select the SSID shown on the camera.</li>
        <li>Enter the password displayed on the camera.</li>
        <li>Select "Connect"</li>
        <li>
          Confirm the connection on the camera with "Ok" to complete the
          pairing.
        </li>
      </ol>
      Camoodoo should now be connected to the camera and display the live image.
    </simple-section>
    <simple-section dark title="Reconnect with Camoodoo">
      After you connected the first time with Camooodoo the connection process
      can be simplyfied:
      <ol>
        <li>Turn on your Canon camera.</li>
        <li>Open the camera menu.</li>
        <li>Select the "Wireless Communication settings" menu item.</li>
        <li>Select the "Wifi Function" menu item.</li>
        <li>Select "Camoodoo".</li>
        <li>Launch Camoodoo on your smartphone.</li>
        <li>Choose the camera.</li>
      </ol>
      Camoodoo should now be connected to the camera and display the live image.
    </simple-section>
  </camoodoo-page>
</template>

<script>
import SimpleSection from "@/sections/SimpleSection.vue";
import CamoodooPage from "@/components/CamoodooPage.vue";

export default {
  components: {
    SimpleSection,
    CamoodooPage,
  },
};
</script>

<style lang="scss" scoped></style>
